import { ReactNode } from 'react';
import { Toaster } from 'src/components/ui/sonner';
import { toast } from 'src/components/ui/toast';

interface ToastOptions {
  message?: string;
  title?: string;
  color?: 'success' | 'info' | 'warning' | 'error';
  /** @deprecated Ignored — toast icons are now determined by type/color. */
  icon?: string;
  persistent?: boolean;
  autoHideDuration?: number;
  onAction?: () => void;
  actionLabel?: string;
}

const defaultTitles: Record<string, string> = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
};

function showToast(options: ToastOptions) {
  const {
    message,
    color = 'success',
    persistent,
    autoHideDuration,
    onAction,
    actionLabel,
  } = options;

  const title = options.title ?? defaultTitles[color];

  toast({
    title,
    description: message,
    type: color,
    duration: persistent ? Infinity : autoHideDuration,
    action:
      onAction && actionLabel
        ? { label: actionLabel, onClick: onAction }
        : undefined,
  });
}

/** @deprecated Kept for backward compat — Toaster no longer needs to wrap children. */
export const ToastProvider = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {children}
      <Toaster position="bottom-right" />
    </>
  );
};

export const useToast = () => ({ showToast });
